export default __webpack_public_path__ + "static/media/0xdae89da41a96956e9e70320ac9c0dd077070d3a5.402264d3.webp";